import { type BigNumberish, utils, constants } from 'ethers';
import { getChainNameFromEnv, getChainIdFromEnv } from '../supportedChains';

// https://www.jacklmoore.com/notes/rounding-in-javascript/
export function roundUpDecimal(num: number, precision: number): number {
    return Number(Math.ceil(Number(num + 'e' + precision)) + 'e-' + precision);
}
export function roundDecimal(num: number, precision: number): number {
    return Number(Math.round(Number(num + 'e' + precision)) + 'e-' + precision);
}

export function formatEtherBalance(balanceInWei: BigNumberish, precision: number = 4): string {
    let ether = utils.formatEther(balanceInWei);

    // if ether is less then lowest possible value with passed precision, render 0
    if (Number.parseFloat(ether) < Number('1e-' + precision)) {
        ether = '0';
    }

    return constants.EtherSymbol + '\u00A0' + roundDecimal(Number.parseFloat(ether), precision);
}

export function shortAddress(address: string): string {
    if (utils.isAddress(address)) {
        if (!address.startsWith('0x')) {
            address = '0x' + address;
        }

        return address.slice(0, 6) + '…' + address.slice(address.length - 4);
    }
    return '';
}
export function shortName(name: string): string {
    if (name.length >= 48) {
        return name.slice(0, 45) + '…';
    }
    return name;
}

export function etherscanUrl(path: string): string {
    const isMainNet = getChainIdFromEnv() === 1;
    const chainName = isMainNet ? 'www' : getChainNameFromEnv();
    return `https://${chainName.toLowerCase()}.etherscan.io${path}`;
}

export function ipfsGatewayLink(tokenUri: string): string {
    if (tokenUri.includes('ipfs://')) {
        return `https://ipfs.1stdibs.com/${tokenUri.replace('ipfs://', 'ipfs/')}`;
    }
    return tokenUri;
}

export function defaultAvatarGradient(address: string): string {
    const res = [];
    for (let i = 2; i < address.length; i += 6) {
        const chunk = address.slice(i, i + 6);
        res.push(chunk);
    }
    return `linear-gradient(180deg, #${res[0]} 0%, #${res[1]} 50%, #${res[2]} 100%)`;
}

export function normalizeAddress(address: string): string {
    if (address.startsWith('0x')) {
        try {
            return utils.getAddress(address.toLowerCase());
        } catch (e) {
            // ignore invalid address error
        }
    }
    return address;
}
